export const featureOn = (featureName) => eventDataProps.data.venue[featureName] || false;
export const mandatoryField = (fieldName) => eventDataProps.data.venue[fieldName] || false;
export const hiddenField = (fieldName) => eventDataProps.data.venue[fieldName] || false;
